/* eslint-disable */
import { defineStore } from 'pinia'
import axios from 'axios'

export const useActorStore = defineStore('actor',
    { state: () => {
        return { 
            actors: [],
            actor:null,
            waiting:true,
            // pagination: {
            //     totalPage: 0,
            //     nextPage: false,
            //     prevPage: false,
            //     currentPage: 1
            // },
            // pages: []
         }
    },
    actions: {
        fetchData(target){
            this.waiting = true
            axios.get(`${process.env.VUE_APP_API_URL}/client/movie/actor?target=${target}`)
            .then(response => {
                this.actors = response.data.data
                // this.pagination = response.data.pagination
                // this.calculatePage()
                this.waiting = false
                console.log(response.data)
            })
            .catch(err => {
                this.waiting = false
                console.log(err)
            })
        },
        fetchDataById(id){
            this.waiting = true
            axios.get(`${process.env.VUE_APP_API_URL}/client/movie/detail?target=${id}`)
            .then(response => {
                this.movie = response.data.data
                this.waiting = false
            })
            .catch(err => {
                this.waiting = false
                console.log(err)
            })
        },
        calculatePage(){
            this.pages = []

            var min = 0
            var max = 0

            var limit = 5

            if(this.pagination.currentPage != 1 && (this.pagination.currentPage % limit) == 0){
                max = this.pagination.currentPage
                min = max - (limit - 1)
            }else if(this.pagination.currentPage == 1){
                min = 1
                max = limit
            }else{
                min = Math.floor(this.pagination.currentPage / limit) * limit
                max = min + limit
                min = min + 1
            }

            for(var x = (min); x <= max; x++){
                if(this.pagination.totalPage >= x){
                    this.pages.push(x)
                }else{
                    break
                }
            }

            console.log(this.pages)
        }
    },getters: {
        getMovies: (state) => state.movies
    }
})